import src from "IMAGE";
export default { src, width: 300, height: 300, blurWidth: 0, blurHeight: 0};
